'use es6';

import { createSelector } from 'reselect';
import { gdprConsentToCommunicateEnabled } from 'conversations-internal-schema/widget-data/operators/gdprConsentToCommunicateEnabled';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
export const shouldRequireConsentToCommunicate = createSelector([getLatestWidgetData], widgetData => gdprConsentToCommunicateEnabled(widgetData));